import { PROJECT_KEY } from "@/src/services/blocks/config";
import type { Post } from "@/src/models/post.model";
export type FollowState = {
  schemaVersion: 1;
  authorId: string;
  desiredFollowing: boolean;
  following: boolean;
  validationState: "pending" | "active" | "rejected" | "inactive";
  appNotificationsEnabled: boolean;
  digestEnabled: boolean;
  epochId: string | null;
  startedAt: string | null;
  revision: string;
  reasonCode: string | null;
};
export type FollowControl = {
  ItemId: string;
  authorId: string;
  followerId: string;
  scopeOrgId: string;
  epochId: string | null;
  desiredFollowing: boolean;
  appNotificationsEnabled: boolean;
  digestEnabled: boolean;
  revision: string;
  requestId: string;
};
export type FollowerNotice = {
  deliveryId: string;
  organizationId: string;
  authorId: string;
  authorName: string;
  eligiblePostCount: number;
  targetPostId: string;
  createdAt: string;
  isRead: boolean;
  type: "followed_author_posts";
};
export type FollowingCards = {
  schemaVersion: 1;
  items: Post[];
  nextCursor: string | null;
};
export type FollowingList = {
  schemaVersion: 1;
  items: {
    authorId: string;
    displayName: string;
    avatarUrl?: string;
    state: FollowState;
  }[];
  nextCursor: string | null;
};
export type AuthorCounts = {
  authorId: string;
  followerCount: number;
  followingCount: number;
  updatedAt: string;
};
export const enabled =
  process.env.EXPO_PUBLIC_FOLLOWING_ENABLED === "true" &&
  !!process.env.EXPO_PUBLIC_FOLLOWING_FUNCTION_ID;
export const scopeKey = (viewer: string, org: string) =>
  ["following-v1", PROJECT_KEY, viewer, org] as const;
export const safeFollowingWhere = (
  viewer: string,
  org: string,
  authorIds: string[],
  search = "",
) => ({
  OrganizationId: {
    eq: org,
  },
  CreatedBy: {
    in: authorIds,
  },
  and: [
    {
      or: [
        {
          visibility: {
            eq: "public",
          },
        },
        {
          and: [
            {
              visibility: {
                eq: "private",
              },
            },
            {
              CreatedBy: {
                eq: viewer,
              },
            },
          ],
        },
        {
          and: [
            {
              visibility: {
                eq: "specific",
              },
            },
            {
              visibleToUserIds: {
                in: [viewer],
              },
            },
          ],
        },
      ],
    },
    ...(search.trim()
      ? [
          {
            content: {
              contains: search.trim(),
            },
          },
        ]
      : []),
  ],
});
export const isSafeNongroup = (post: Post, viewer: string) =>
  post.visibility === "public" ||
  (post.visibility === "private" && post.CreatedBy === viewer) ||
  (post.visibility === "specific" && !!post.visibleToUserIds?.includes(viewer));
export function assertVersion<
  T extends {
    schemaVersion: number;
  },
>(value: T): T {
  if (value?.schemaVersion !== 1)
    throw new Error("FOLLOWING_VERSION_UNSUPPORTED");
  return value;
}
